<template>
    <ModalTheme :with-content="true" @close="closeModal" :theme="true" :fix-height="false">
        <template slot="main">
            <loader :loading="isLoading" v-if="isLoading"></loader>
            <div class="wrapper">
                <div>
                    <div class="headline bold">Add items to forecasts</div>
                    <div class="headline-2">Eligible forecasts:</div>
                    <div class="middle">
                        <div class="small-text">status / forecast ref + name / current qty of items</div>
                        <table>
                            <tbody>
                                <tr v-for="forecast in forecasts" :key="forecast.id">
                                    <td>
                                        <ForecastStatus :status="forecast.deleted ? 'DELETE' : forecast.status" :short="true" /><span class="name-ref"
                                            >{{ forecast.reference }} - {{ forecast.name }} ({{ forecast.numberOfItems }})</span
                                        >
                                    </td>
                                    <td style="text-align: right"><input v-model="selectedForecasts" :value="forecast" type="checkbox" /></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="end">
                    <div><ClientColorButton @click="onSave">Add to forecasts</ClientColorButton></div>
                </div>
            </div>
        </template>
    </ModalTheme>
</template>

<script>
import ModalTheme from "@/components/ui/ModalTheme";
import { mapActions, mapGetters } from "vuex";
import loader from "@/components/loader/loader";
import ForecastStatus from "@/components/forecasts/elements/ForecastStatus";
import historyService from "@/services/history";
import { OBJECT_TYPE, SHORT_DESCRIPTION } from "@/components/history/constants";

export default {
    components: { ForecastStatus, ModalTheme, loader },
    props: {
        items: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            doSave: false,
            selectedForecasts: [],
            isLoading: false
        };
    },
    created() {
        this.populate();
    },
    computed: {
        ...mapGetters("forecast", { forecasts: "itemsModifiable" })
    },
    methods: {
        ...mapActions("forecast", { populate: "populate" }),
        ...mapActions("forecast", { updateItems: "updateItems" }),
        closeModal() {
            this.$emit("close");
        },
        onSave() {
            this.isLoading = true;
            let forecastsToUpdate = [];
            this.selectedForecasts.forEach(forecast => {
                let forecastCopy = { ...forecast };
                let forecastNeedsUpdate = false;
                forecastCopy.items = [];
                this.items.forEach(item => {
                    forecastCopy.items.push(item);
                    forecastNeedsUpdate = true;
                });
                if (forecastNeedsUpdate) {
                    forecastsToUpdate.push(forecastCopy);
                }
            });
            try {
                for (const fc of forecastsToUpdate) {
                    this.updateItems({ forecast: fc, itemsToAdd: fc.items })
                        .then(() => {
                            this.isLoading = false;
                            this.dialogSuccess(SHORT_DESCRIPTION.ADD_ITEM);
                        })
                        .catch(() => {
                            this.isLoading = false;
                            this.$swal({
                                text: "ERROR TO ADD ITEM TO FORECAST " + fc.name,
                                type: "error",
                                confirmButtonText: "OK",
                                confirmButtonColor: "rgb(135, 135, 135)",
                                allowOutsideClick: false,
                                allowEscapeKey: false
                            });
                        });
                }
            } catch (e) {
                console.log(e);
                this.dialogError(`Items could not be added`);
            }
            this.isLoading = false;
            this.$emit("close");
        }
    }
};
</script>
<style scoped lang="scss">
.wrapper {
    text-transform: uppercase;
    font-size: 2em;
    .headline {
        margin-bottom: 20px;
        font-size: 1.4em;
    }
    .headline-2 {
        text-transform: none;
        padding-bottom: 25px;
        font-size: 1.1em;
        font-weight: bold;
    }
    .middle {
        div {
            margin-left: auto;
            margin-right: auto;
            padding: 5px 0;
        }
        .small-text {
            font-size: 0.6em;
            color: #aeaeae;
            text-transform: none;
        }
        table {
            width: 100%;
            border-collapse: collapse;
            border-spacing: 0;
            margin-bottom: 25px;
            td {
                border-top: 1px solid #aeaeae;
                border-bottom: 1px solid #aeaeae;
                padding: 10px 5px;
            }
        }
        .name-ref {
            padding-left: 15px;
            font-weight: bold;
        }
    }
    .end {
        display: flex;
        div {
            margin-left: auto;
        }
    }
}
.texts {
    margin-left: 10px;
}
</style>



// WEBPACK FOOTER //
// MultiSelectModal.vue?4fc465f0